import { render, staticRenderFns } from "./ViewStandardisedJobProfiles.vue?vue&type=template&id=7c1d65ae&scoped=true&"
import script from "./ViewStandardisedJobProfiles.vue?vue&type=script&lang=ts&"
export * from "./ViewStandardisedJobProfiles.vue?vue&type=script&lang=ts&"
import style0 from "./ViewStandardisedJobProfiles.vue?vue&type=style&index=0&id=7c1d65ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d65ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VRow,VSkeletonLoader})
